export default {"src":"/_next/static/media/payment-systems.c3e8c876.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};